import React from 'react';

class AppErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { error: null };
  }

  static getDerivedStateFromError(error) {
    return { error };
  }

  componentDidCatch(error, errorInfo) {
    console.error('[frontend] render failed', error, errorInfo);
  }

  render() {
    const { error } = this.state;

    if (error) {
      return (
        <main className="page-shell">
          <div className="card">
            <h1>Frontend-Fehler</h1>
            <p>Die Oberfläche konnte nicht geladen werden.</p>
            <p>
              <strong>Fehler:</strong> {error.message || 'Unbekannter Fehler'}
            </p>
            <button type="button" onClick={() => window.location.reload()}>
              Seite neu laden
            </button>
          </div>
        </main>
      );
    }

    return this.props.children;
  }
}

export default AppErrorBoundary;
